import React, { useState, useRef, useEffect } from 'react';
import { findDOMNode } from 'react-dom';
import { getWeek } from '@/utils';
import Calendar from 'rc-calendar';
import zhCN from 'rc-calendar/lib/locale/zh_CN';
import 'rc-calendar/assets/index.css';
import './index.scss'
import moment from 'moment';
import 'moment/locale/zh-cn';

const TimeTool = (props) => {

  const { onChange } = props;
  
    const calendarRef = useRef();

    const timeRef = useRef(moment());
  
    const [ visible, setVisible ] = useState(false);
  
    const leftClick = async ()  => {
      timeRef.current = timeRef.current.add(-1, 'days');
      if (onChange) onChange(timeRef.current);
    }
  
    const rightClick = async () => {
      timeRef.current =  timeRef.current.add(1, 'days');
      if (onChange) onChange(timeRef.current);
    }
  
    const onDateChange = (date) => {
      if (date.locale() === 'en'){
        console.log(moment().valueOf());
        date = moment(moment().valueOf());
      }
      timeRef.current = date;
      console.log(timeRef.current.locale());
      if (onChange) onChange( timeRef.current );
    }

    const handleClickOutside = (e) => {
      if(calendarRef.current){
        // 组件已挂载且事件触发对象不在div内
            let result = findDOMNode(calendarRef.current).contains(e.target);
            if(!result) {
                setVisible(false)
            }  
        }
    }

    useEffect(() => {
      document.addEventListener('touchstart', (e)=> handleClickOutside(e), false);
      return () => {
        document.removeEventListener('touchstart', (e)=> handleClickOutside(e), false);
      }
    }, [])

    return (
      <>
        <div className="time-tools">
          <div className="ico pre-day left" onClick={leftClick}></div>
              <div className="time-day" onClick={() => setVisible(true)} >
              { timeRef.current && (
                <>
                  <span className="time-text">
                    { timeRef.current.format('MM月DD日')} {getWeek( timeRef.current)}
                  </span>
                  <em className="time-calendar"></em>
                </>
              )}
            </div>
          <div className="ico next-day right" onClick={rightClick}></div>
        </div>
        <Calendar 
          ref={(e) => calendarRef.current = e }
          className="tools-calendar"
          style={{ width: '30vw' }}
          locale={zhCN}        
          showDateInput={false}
          visible={visible}
          value={timeRef.current}
          onChange={onDateChange}
        >
        </Calendar> 
      </>
    );
  };

  export default TimeTool;